export default __webpack_public_path__ + "static/media/url-customizer.5ef13f0b.webp";